import { combineReducers } from 'redux';

const inVestList = (state = [], action)=>{
	switch(action.type){
		case 'MY_INVEST_LIST':
			return action.text;
		default:
			return state;
	}
}
const inVestListGm = (state = [], action)=>{
	switch(action.type){
		case 'MY_INVEST_LIST_GM':
			return action.text;
		default:
			return state;
	}
}
const inVestListSm = (state = [], action)=>{
	switch(action.type){
		case 'MY_INVEST_LIST_SM':
			return action.text;
		default:
			return state;
	}
}
const inVestListSF = (state = [], action)=>{
	switch(action.type){
		case 'MY_INVEST_LIST_SF':
			return action.text;
		default:
			return state;
	}
}
const inVestListJhlc = (state = [], action)=>{
	switch(action.type){
		case 'MY_INVEST_LIST_JHLC':
			return action.text;
		default:
			return state;
	}
}
const inVestListZh = (state = [], action)=>{
	switch(action.type){
		case 'MY_INVEST_LIST_ZH':
			return action.text;
		default:
			return state;
	}
}
const inDividendMethod = (state = '0', action)=>{
	switch(action.type){
		case 'DIVIDEND_METHOD':
			return action.text;
		default:
			return state;
	}
}
const inFundType = (state = '', action)=>{
	switch(action.type){
		case 'FUND_TYPE':
			return action.text;
		default:
			return state;
	}
}
const trustChannelShare = (state = {fundInfo:{},trustChannelShareResponse:[],isOpenBuy:true,fundIncome:[{allIncome:0,dayIncome:'',deadLine:null}]}, action)=>{
	switch(action.type){
		case 'TRUST_CHANNE_SHARE':
			return action.text;
		default:
			return state;
	}
}

//在途资金交易明细列表
const assetInTransitList = (state = [], action)=>{
	switch(action.type){
		case 'ASSET_IN_TRANSIT_LIST':
			return action.text;
		default: 
			return state;
	}
}

const myInvest = combineReducers({
	inVestList,
	inVestListJhlc,
	inVestListZh,
	inVestListSm,
	inVestListSF,
	inVestListGm,
	inDividendMethod,
	inFundType,
	trustChannelShare,
	assetInTransitList
})

export default myInvest;


// WEBPACK FOOTER //
// ./src/reducer/myAssets/myInvestReducer.js